exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header{padding:0!important}.modal-header .close{font-size:30px;font-weight:400;margin-right:15px;margin-top:0}.modal-body{padding-top:0;max-height:510px}@media (min-width:992px){.modal-lg{width:800px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b1fec8c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/ModalImage.vue
// module id = 738
// module chunks = 0